import { apiAuth, apiResponseType } from ".";

export const getDistributionsProcessByUnityId = (unit_id: string, page: number = 1) => {
  return apiAuth.get(
    `distribution-processes?unity_id=${unit_id}&page=${page}&status_id=1&per_page=200`
  ) as apiResponseType;
};

export const getAllDistributionsProcessByUnityId = (unit_id: string) => {
  return apiAuth.get(
    `distribution-processes?unity_id=${unit_id}&per_page=2000&distribution_type_ids=1,3,5`
  ) as apiResponseType;
};

export const acceptDistribution = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/accept-distribution`) as apiResponseType;

export const acceptDistributionBetweenUnities = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/accept-distribution-between-unities`) as apiResponseType;

export const rejectDistributionBetweenUnities = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/reject-distribution-between-unities`) as apiResponseType;

export const rejectDistribution = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/reject-distribution`) as apiResponseType;

export const acceptDistributionSellerToUnity = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/accept-distribution-seller-for-unity`) as apiResponseType;

export const rejectDistributionSellerToUnity = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/reject-distribution-seller-for-unity`) as apiResponseType;

export const acceptDistributionBySeller = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/accept-seller-distribution`) as apiResponseType;

export const rejectDistributionBySeller = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/reject-seller-distribution`) as apiResponseType;

export const getDistributionProcessFiles = (ids: number[]) =>
  apiAuth.post(`/distribution-processes/files`, { ids }) as apiResponseType;